module.exports = __webpack_public_path__ + "static/media/heikki-rostila-quote.9be907d9.png";